/**
 * AI Management Services
 * Factory function and exports for all AI-related services
 */
import { AiFeatureFlagService } from './AiFeatureFlagService';
import { AiWorkflowPresetService } from './AiWorkflowPresetService';
import { AiRecordSchemaService } from './AiRecordSchemaService';
import { AiRequestLogService } from './AiRequestLogService';
import { AiModelService } from './AiModelService';
import { AiContentService } from './AiContentService';
import { AiExtractionService } from './AiExtractionService';
import { AiAnalyticsService } from './AiAnalyticsService';
import { AiBudgetAnalyticsService } from './AiBudgetAnalyticsService';
import { AiWorkflowService } from './AiWorkflowService';
import { AiDocumentService } from './AiDocumentService';
import { AiClassificationService } from './AiClassificationService';
import { AiReportService } from './AiReportService';
export { AiFeatureFlagService } from './AiFeatureFlagService';
export { AiWorkflowPresetService } from './AiWorkflowPresetService';
export { AiRecordSchemaService } from './AiRecordSchemaService';
export { AiRequestLogService } from './AiRequestLogService';
export { AiModelService } from './AiModelService';
export { AiContentService } from './AiContentService';
export { AiExtractionService } from './AiExtractionService';
export { AiAnalyticsService } from './AiAnalyticsService';
export { AiBudgetAnalyticsService } from './AiBudgetAnalyticsService';
export { AiWorkflowService } from './AiWorkflowService';
export { AiDocumentService } from './AiDocumentService';
export { AiClassificationService } from './AiClassificationService';
export { AiReportService } from './AiReportService';
export function createAiServices(http, config) {
    return {
        featureFlag: new AiFeatureFlagService(http, config),
        workflowPreset: new AiWorkflowPresetService(http, config),
        recordSchema: new AiRecordSchemaService(http, config),
        requestLog: new AiRequestLogService(http, config),
        model: new AiModelService(http, config),
        content: new AiContentService(http, config),
        extraction: new AiExtractionService(http, config),
        analytics: new AiAnalyticsService(http, config),
        budgetAnalytics: new AiBudgetAnalyticsService(http, config),
        workflow: new AiWorkflowService(http, config),
        document: new AiDocumentService(http, config),
        classification: new AiClassificationService(http, config),
        report: new AiReportService(http, config),
    };
}
//# sourceMappingURL=index.js.map